<template>
  <v-container fluid id="teleFileupload" tag="section">
    <!-- Alert Message  -->
    <template v-if="alert">
      <v-alert v-if="alert.progress > 0" :type="alert.type" class="tele-alert">
        {{alert.content}}
        <v-progress-linear absolute bottom color="amber" height="6" v-model="alert.progress"></v-progress-linear>
      </v-alert>
    </template>

    <v-form enctype="multipart/form-data" lazy-validation>
      <v-row>
        <v-col>
          <base-material-card icon="mdi-upload" title="File Upload">
            <v-row class="pa-5">
              <v-col cols="12" class="mt-5">
                <v-file-input
                  v-model="file"
                  placeholder="Upload your XML file"
                  accept="text/xml"
                  label="File input"
                  prepend-icon="mdi-paperclip"
                >
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary">{{ text }}</v-chip>
                  </template>
                </v-file-input>
              </v-col>
              <v-col cols="12">
                <div class="d-flex justify-center mb-2">
                  <v-btn
                    color="primary"
                    class="primary-hover-shadow"
                    @click="uploadFile"
                    large
                  >Upload</v-btn>
                </div>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import $ from "jquery";
export default {
  data: () => ({
    file: null,
    xmlArray: [],
    alert: null
  }),
  watch: {
    file() {
      this.xmlArray = [];
      // see if file input changes
      // then add xmlArray to send this array to backend
      console.log(this.file);
      this.getFinalXML(this.file);
    },
    alert(e) {
      if (e.progress == 100) {
        let x = setInterval(() => {
          if (e.progress < 0) {
            clearInterval(x);
          }
          e.progress -= 1;
        }, e.seconds * 10);
      }
    }
  },
  methods: {
    uploadFile() {
      let self = this;

      if (this.xmlArray.length > 0) {
        this.xmlArray.forEach(dataObj => {
          this.$http
            .post("/show/create/", dataObj)
            .then(function(response) {
              console.log("<Show> inserted to database");
              self.insertAlert("success", "Your XML file is now inserted");
            })
            .catch(function(error) {
              self.insertAlert(
                "error",
                "Ops, cannot insert the show, try again later"
              );
              console.log(error);
            });
        });
      } else {
        this.insertAlert(
          "error",
          "Please make sure your XML file contain <show> tag"
        );
      }
    },
    getFinalXML(file) {
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onloadend = () => {
        this.parseXML(reader.result);
      };
    },
    parseXML(content) {
      let xmlDocument = $.parseXML(content),
        $xml = $(xmlDocument);
      // For each show tag in xml
      $.each($xml.find("Show"), (key, value) => {
        console.log();
        const myShow = {
          StartDateBroadcast: this.getValueTagXML(value, "StartDateBroadcast"),
          StartTime: this.getValueTagXML(value, "StartTime"),
          Length: this.getValueTagXML(value, "Length"),
          ProgramName: this.getValueTagXML(value, "ProgramName"),
          TitleName: this.getValueTagXML(value, "TitleName"),
          TitleCode: this.getValueTagXML(value, "TitleCode"),
          Season: this.getValueTagXML(value, "Season"),
          TitleNotes: this.getValueTagXML(value, "TitleNotes"),
          TitleSynopsisLogline: this.getValueTagXML(
            value,
            "TitleSynopsisLogline"
          ),
          ProgramTrafficReference: this.getValueTagXML(
            value,
            "ProgramTrafficReference"
          ),
          "FCCRatingV-ChipCodes": this.getValueTagXML(
            value,
            "FCCRatingV-ChipCodes"
          ),
          ParadigmID: this.getValueTagXML(value, "ParadigmID"),
          SeriesName: this.getValueTagXML(value, "SeriesName"),
          SeriesNameTitleName: this.getValueTagXML(
            value,
            "SeriesNameTitleName"
          ),
          SeriesSynopsis: this.getValueTagXML(value, "SeriesSynopsis"),
          ProgramClassName: this.getValueTagXML(value, "ProgramClassName"),
          ScheduleElementIDUnique: this.getValueTagXML(
            value,
            "ScheduleElementIDUnique"
          ),
          SeriesPrefix: this.getValueTagXML(value, "SeriesPrefix"),
          ProgramStarAll: this.getValueTagXML(value, "ProgramStarAll"),
          "HD-SD": this.getValueTagXML(value, "HD-SD"),
          TitleCaptionState: this.getValueTagXML(value, "TitleCaptionState")
        };
        this.xmlArray.push(myShow);
      });
    },
    getValueTagXML(target, tag) {
      return $(target)
        .find(tag)
        .text();
    },
    insertAlert(type, content) {
      const obj = {
        type: type,
        content: content,
        progress: 100,
        seconds: 10
      };
      this.alert = obj;
    }
  }
};
</script>

<style>
</style>